module.exports = __webpack_public_path__ + "static/media/website-04.395c78c5.png";